export default __webpack_public_path__ + "static/media/yo6.424b1603.png";